import BaseFormGroup from '@material-ui/core/FormGroup'

const FormGroup = BaseFormGroup

export default FormGroup
